module.exports = __webpack_public_path__ + "static/media/img_9__1.6422b202.jpg";